import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../helpers/numbers'

import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../CampaignForms/fields'

const RemainingCampaignBudgetFields = ({ budgetType, formik, remainingBudget }) => {
  const { t } = useTranslation()

  // todo Currently combined campaign has wrong currency symbol, use it when it's fixed
  // const { currency_symbol: currencySymbol } = useSelector(combinedCampaignsSelector)
  const { currency_symbol: currencySymbol } = useSelector(selectedFacebookAdAccountSelector)

  return (
    <>
      {budgetType === BUDGET_LIFETIME && (
        <>
          <p>{t('A total budget for the whole campaign.')}</p>
          <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
          <Field
            type="number"
            formik={formik}
            name={BUDGET_LIFETIME}
            placeholder={t('Lifetime Budget')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        </>
      )}
      {budgetType === BUDGET_DAILY && (
        <>
          <p>{t('Set an average amount you want to spend each day.')}</p>
          <p>
            {t(
              'Some functions (such as targeting ads during specific times of day) aren’t available if you select this option, so we don’t usually recommend it.'
            )}
          </p>
          <Field
            type="number"
            formik={formik}
            name={BUDGET_DAILY}
            placeholder={t('Daily Budget')}
            symbol={currencySymbol}
            autoComplete="off"
          />
        </>
      )}
    </>
  )
}

export default RemainingCampaignBudgetFields
